import { createContext } from 'react';

import OverlayStatusData from './types/OverlayStatusData';

const OverlayStatusContext = createContext<OverlayStatusData>({
    closeOverlay: () => {},
    forceOverlay: () => {},
    enableParentRedirects: () => {},
    overlayIsClosing: false,
    inOverlay: false,
    parentSupportsRedirects: false,
    openerUrl: window.location.href,
});

export default OverlayStatusContext;
